import { useState, useRef } from "react";
import { UploadCloud, X } from "lucide-react";
import { toast } from "sonner";

export const ProofUpload = ({ onSubmit, busy }) => {
  const [file, setFile] = useState(null);
  const [preview, setPreview] = useState(null);
  const input = useRef(null);

  const pick = (f) => {
    if (!f || !f.type.startsWith("image/")) return;
    if (f.size > 10 * 1024 * 1024) return toast.error("Image is too large (max 10 MB).");
    if (preview) URL.revokeObjectURL(preview);
    setFile(f);
    setPreview(URL.createObjectURL(f));
  };

  return (
    <div data-testid="proof-upload" className="space-y-4">
      <p className="eyebrow">Step 2 · Upload payment screenshot</p>
      <input ref={input} data-testid="proof-file-input" type="file" accept="image/*" className="hidden" onChange={(e) => pick(e.target.files?.[0])} />
      {preview ? (
        <div className="relative w-40 aspect-[9/16] bg-[#F5EFE6] border border-[#C5A059]/40">
          <img data-testid="proof-preview" src={preview} alt="Payment proof" className="h-full w-full object-cover" />
          <button data-testid="proof-remove-button" aria-label="Remove" onClick={() => { setFile(null); setPreview(null); }} className="absolute -top-3 -right-3 h-7 w-7 rounded-full bg-[#0F0F0F] text-white flex items-center justify-center">
            <X className="h-3.5 w-3.5" />
          </button>
        </div>
      ) : (
        <button
          data-testid="proof-pick-button"
          onClick={() => input.current?.click()}
          onDragOver={(e) => e.preventDefault()}
          onDrop={(e) => { e.preventDefault(); pick(e.dataTransfer.files?.[0]); }}
          className="w-full border border-dashed border-[#0F0F0F]/30 hover:border-[#C5A059] bg-white py-10 flex flex-col items-center gap-3 transition-colors"
        >
          <UploadCloud className="h-7 w-7 text-[#C5A059]" strokeWidth={1.5} />
          <span className="text-sm">Choose or drop your screenshot</span>
        </button>
      )}
      <button
        data-testid="proof-submit-button"
        disabled={!file || busy}
        onClick={() => onSubmit(file)}
        className="w-full bg-[#0F0F0F] text-[#C5A059] py-4 text-xs tracking-[0.3em] uppercase disabled:opacity-40 transition-shadow hover:shadow-[0_0_30px_rgba(197,160,89,0.35)]"
      >
        {busy ? "Submitting…" : "Submit payment proof"}
      </button>
    </div>
  );
};
